// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__1z5rj","rightAdornment":"Header_rightAdornment__2Op-m"};